import { useEffect, useState, useRef, useMemo } from "react";
import axios from "../../../../axios";
import {
  errorToast,
  successToast,
  warningToast,
} from "../../../../utils/toast";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { useTranslation } from "react-i18next";
import TimerImage from "../../../../Images/timeupimage.png";
import Loding from "../../../../componant/Loader/Loding";
import { useToast } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";
import {
  CheckCircle,
  XCircle,
  AlertCircle,
  Clock,
  SkipForward,
  ArrowRight,
  Info,
  HelpCircle,
  X,
} from "lucide-react";
import { useUser } from "../../../../hooks/use-user";
import { useNavigate } from "react-router-dom";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa6";
import ContestResultModal from "../contest/contestResultModal";
import EngHinToggleButton from "../../../../componant/EngHinToggleButton";
import { getContestReturnUrl } from "../contest/contestNavigation";

const ContestQuestion = (props) => {
  const toast = useToast({ position: "top" });
  const location = useLocation();
  const returnUrl = location.state?.returnUrl || getContestReturnUrl();

const contestIdFromState = location.state?.contestId||sessionStorage.getItem("contestId");
console.log("Contest ID from state:", contestIdFromState);
 // Debug log
//  const location = useLocation();

useEffect(() => {
  if (location.state?.contestId) {
    sessionStorage.setItem(
      "contestId",
      location.state.contestId
    );
  }
}, [location.state]);
  const [t, i18n] = useTranslation();
  const [loading, setLoading] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [data, setData] = useState({});
  const [nextdata, setNextdata] = useState({});
  const [userdata, setUserdata] = useState({});
  const [selectedOption, setSelectedOption] = useState(null);
  const [correctAnswers, setCorrectAnswers] = useState(0);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isCorrect, setIsCorrect] = useState(false);
  const [timeLeft, setTimeLeft] = useState(0);
  const [showButton, setShowButton] = useState(false);
  const [showTimerButton, setShowTimerButton] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [TimeOut, setIsTimeout] = useState(false);
  const timerRef = useRef(null);
  const autoSubmitRef = useRef(false);
  const submittingContestRef = useRef(false);
  const { data: user } = useUser();
  const [Contestdata, setContestData] = useState([]);
  const [userContestdata, setUserContestData] = useState([]);
  const [totalQuestions, setTotalQuestions] = useState(0);
  const [contestCompleted, setContestCompleted] = useState(false);
  const [contestResultModal, setContestResultModal] = useState(false);
  const [completeData, setCompleteData] = useState({
    rightCount: 0,
    wrongCount: 0,
    skipCount: 0,
  });
  const [showSubmitModal, setShowSubmitModal] = useState(false);
  const [contestSummary, setContestSummary] = useState({});
  const [autoSubmittedOnExpiry, setAutoSubmittedOnExpiry] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState("en");
  const [contestAttemptTiming, setContestAttemptTiming] = useState({
    startedAt: null,
    expiresAt: null,
  });
  const navigate = useNavigate();

  const questionStartedAtRef = useRef(Date.now());

  const handleContestFinished = async ({
    shouldSubmitContest = false,
    shouldOpenResultModal = true,
  } = {}) => {
    if (shouldSubmitContest && contestIdFromState && !contestCompleted) {
      await confirmSubmitContest({
        shouldNavigate: false,
        shouldOpenResultModal,
      });
      return;
    }

    const summary = await fetchContestSummary();
    if (summary) {
      setContestSummary(summary);
    }

    if (shouldOpenResultModal) {
      setContestResultModal(true);
    }
  };

  useEffect(() => {
    async function fetchData() {
      axios.get("getAllContestForUser").then((response) => {
        if (response?.data) {
          setContestData(response?.data?.result);
        }
      });
    }
    fetchData();
  }, []);
  const normalizeContestSummary = (summary = {}) => {
    const summaryData = Array.isArray(summary) ? summary[0] || {} : summary;
    const rightCount =
      summaryData.rightCount ??
      summaryData.totalRightAnswerCount ??
      completeData.rightCount ??
      0;
    const wrongCount =
      summaryData.wrongCount ??
      summaryData.totalWrongAnswerCount ??
      completeData.wrongCount ??
      0;
    const attempts =
      summaryData.totalAttempts ??
      Number(rightCount || 0) + Number(wrongCount || 0);
    const questionCount =
      summaryData.totalQuestions ??
      summaryData.totalQuestion ??
      summaryData.totalContestQuestions ??
      totalQuestions ??
      attempts;
    const skipCount =
      summaryData.skipCount ??
      summaryData.totalSkipCount ??
      completeData.skipCount ??
      Math.max(Number(questionCount || 0) - Number(attempts || 0), 0);

    return {
      ...summaryData,
      totalQuestions: questionCount,
      rightCount,
      wrongCount,
      skipCount,
      score:
        summaryData.score ??
        summaryData.finalScore ??
        Math.max(Number(rightCount || 0) - Number(wrongCount || 0) * 0.25, 0),
      accuracy:
        summaryData.accuracy ??
        (attempts > 0
          ? Math.round((Number(rightCount || 0) / Number(attempts || 0)) * 100)
          : 0),
      userName: summaryData.userName || summaryData.name || userdata?.name,
      contestId: summaryData.contestId || contestIdFromState,
    };
  };

  const fetchContestSummary = async () => {
    const activeContestId = contestIdFromState;
    if (!activeContestId) return null;

    try {
      const [detailsRes, questionsRes] = await Promise.all([
        axios.get("contest-result-summary", {
          params: { contestId: activeContestId },
        }),
        axios.get(`getContestQuestionsByContestId/${activeContestId}`),
      ]);

      const details = detailsRes?.data?.result || {};
      const questions = questionsRes?.data?.result?.questions;
      const questionCount = Array.isArray(questions) ? questions.length : 0;
      const summary = normalizeContestSummary({
        ...details,
        totalQuestions: questionCount || details.totalQuestions,
        rightCount: details.totalRightAnswerCount || 0,
        wrongCount: details.totalWrongAnswerCount || 0,
        totalAttempts: details.totalAttempts || 0,
        accuracy: details.accuracy || 0,
        totalTimeTaken: details.totalTimeTaken || 0,
        name: details.name,
        contestId: details.UniqueContestId || activeContestId,
        contestName: details.contestName,
        totalContestSlot: details.totalContestSlot,
        userRank: details.hasContestEnded ? details.userRank : null,
        winningAmount: details.hasContestEnded ? details.winningAmount : 0,
        totalUserContestJoinedCount: details.totalUserContestJoinedCount,
      });
      setContestSummary(summary);
      return summary;
    } catch (error) {
      try {
        const response = await axios.get(
          `getContestResults/${activeContestId}`,
        );
        const summary = normalizeContestSummary(
          response?.data?.result || response?.data?.data || {},
        );
        setContestSummary(summary);
        return summary;
      } catch (fallbackError) {
        errorToast(
          fallbackError?.response?.data?.message ||
            error?.response?.data?.message ||
            "Failed to load contest summary",
        );
        return null;
      }
    }
  };

  useEffect(() => {
    fetchContestSummary();
  }, [contestIdFromState]);

  useEffect(() => {
    if (Contestdata && Contestdata.length > 0) {
      const activeContestId = contestIdFromState;
      const result = Contestdata.find((el) => el._id == activeContestId);
      setUserContestData(result);
      syncContestAttemptTiming(result);
    }
  }, [Contestdata, contestIdFromState]);

  const getTimingFromPayload = (payload) => {
    const candidates = [
      payload,
      payload?.result,
      payload?.data,
      payload?.userContest,
      payload?.userContestData,
      payload?.contestUser,
      payload?.contestAttempt,
      payload?.contestSession,
      payload?.result?.userContest,
      payload?.result?.userContestData,
      payload?.data?.userContest,
      payload?.data?.userContestData,
      payload?.nextQestion,
      payload?.nextQuestion,
      payload?.nextQestion?.userContest,
      payload?.nextQuestion?.userContest,
    ];

    for (const item of candidates) {
      if (item?.expiresAt || item?.startedAt) {
        return {
          startedAt: item.startedAt || null,
          expiresAt: item.expiresAt || null,
        };
      }
    }

    return null;
  };

  const syncContestAttemptTiming = (payload) => {
    const timing = getTimingFromPayload(payload);
    if (!timing?.expiresAt && !timing?.startedAt) return;

    setContestAttemptTiming((prev) => ({
      startedAt: timing.startedAt || prev.startedAt,
      expiresAt: timing.expiresAt || prev.expiresAt,
    }));
  };

  const getContestTimeLeft = (contest, attemptTiming = {}) => {
    const attemptExpiresAt = getTimeMs(attemptTiming?.expiresAt);
    if (attemptExpiresAt !== null) {
      return Math.max(Math.floor((attemptExpiresAt - Date.now()) / 1000), 0);
    }

    if (!contest?.startTime || !contest?.endTime) return 0;

    const now = Date.now();
    const start = new Date(contest.startTime).getTime();
    const end = new Date(contest.endTime).getTime();

    if (now < start) {
      return Math.max(Math.floor((end - start) / 1000), 0);
    }

    if (now >= start && now < end) {
      return Math.max(Math.floor((end - now) / 1000), 0);
    }

    return 0;
  };

  const getTimeMs = (value) => {
    if (!value) return null;
    const timeMs = new Date(value).getTime();
    return Number.isFinite(timeMs) ? timeMs : null;
  };
  const isContestRunningAt = (item, now) => {
    const startMs = getTimeMs(item?.startTime);
    const endMs = getTimeMs(item?.endTime);
    return startMs !== null && endMs !== null && now >= startMs && now < endMs;
  };

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (!isContestRunningAt(userContestdata, Date.now())) return;

      e.preventDefault();
      e.returnValue = "";
    };

    const handlePopState = () => {
      if (!isContestRunningAt(userContestdata, Date.now())) return;

      // const shouldLeave = window.confirm(
      //   "⚠️ Live Contest chal raha hai.\n\nContest chhodne se pehle submit kar dein.\n\nOK = Contest Chhod Do\nCancel = Contest Continue Karo"
      // );
      const shouldLeave = setShowSubmitModal(true);
      if (!shouldLeave) {
        window.history.pushState(null, "", window.location.href);
      }
    };

    window.history.pushState(null, "", window.location.href);

    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("popstate", handlePopState);
    };
  }, [userContestdata,contestIdFromState]);

  useEffect(() => {
    if (
      !contestAttemptTiming?.expiresAt &&
      (!userContestdata?.startTime || !userContestdata?.endTime)
    ) {
      return;
    }

    const updateTimer = () => {
      const seconds = getContestTimeLeft(userContestdata, contestAttemptTiming);
      setTimeLeft(seconds);

      if (seconds <= 0) {
        if (!contestCompleted && !submittingContestRef.current) {
          setTimeUp(true);
          setIsDisabled(true);
          setAutoSubmittedOnExpiry(true);
          void confirmSubmitContest({
            shouldNavigate: false,
            shouldOpenResultModal: true,
          });
        }
      }
    };

    updateTimer();

    const interval = setInterval(updateTimer, 1000);

    return () => clearInterval(interval);
  }, [
    contestAttemptTiming?.expiresAt,
    userContestdata?.startTime,
    userContestdata?.endTime,
  ]);

  const formatTimeLeft = (seconds) => {
    const total = Number(seconds || 0);

    const hours = Math.floor(total / 3600);
    const minutes = Math.floor((total % 3600) / 60);
    const secs = total % 60;

    if (hours > 0) {
      return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
        2,
        "0",
      )}:${String(secs).padStart(2, "0")}`;
    }

    return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(
      2,
      "0",
    )}`;
  };

  const fetchData = async () => {
    setLoading(true);
    setShowTimerButton(false);

    try {
      const activeContestId = contestIdFromState;
      const response = await axios.get(`getUserContestQuestion`, {
        params: { contestId: activeContestId },
      });
      if (response?.data) {
        syncContestAttemptTiming(response.data);
        if (!response.data.result) {
          clearInterval(timerRef.current);
          await handleContestFinished({ shouldSubmitContest: true });
          return;
        }
        setShowTimerButton(true);
        setData(response.data.result);
      }
    } catch (error) {
      if (error?.response?.data?.message === "No questions available") {
        clearInterval(timerRef.current);
        await handleContestFinished({ shouldSubmitContest: true });
      } else if (
        error?.response?.data?.message?.includes("time has ended") ||
        error?.response?.data?.message?.includes("Contest has ended")
      ) {
        // Contest time has ended, force submit
        clearInterval(timerRef.current);
        setTimeUp(true);
        setAutoSubmittedOnExpiry(false);
        errorToast("Contest time has ended");
        void confirmSubmitContest({ shouldNavigate: false });
      }
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (data?._id) {
      questionStartedAtRef.current = Date.now();
    }
  }, [data?._id]);

  const getQuestionTimeTaken = () => {
    return Math.max(
      1,
      Math.ceil((Date.now() - questionStartedAtRef.current) / 1000),
    );
  };

  useEffect(() => {
    if (user) {
      fetchData();
    }
  }, [user, contestIdFromState]);
  const quetionsLength = async () => {
    axios
      .get(`getContestQuestionsByContestId/${userContestdata._id}`)
      .then((res) => {
        const questions = res?.data?.result?.questions;
        console.log(questions.length, "quetions length");

        if (Array.isArray(questions)) {
          setTotalQuestions(questions.length);
        }
      })
      .catch((err) => {
        setTotalQuestions(0);
        // toast.error("Something went wrong. Please try again.");
      });
  };

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      fetchQuestions();
    }
  }, [data, selectedLanguage]);

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      // setTimerBasedOnQuesType(data.quesType);
      setIsDisabled(false);
      setIsSubmitted(false); // Ensure state reset when new data loads
      setIsCorrect(false);
      setSelectedOption(null);
    }
  }, [data]);

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      setShowButton(false);
      setIsTimeout(false);
      // startTimer();
    }
  }, [questions]);

  const setTimerBasedOnQuesType = (quesType) => {
    if (quesType === "reasoning") {
      // setTimeLeft(50);
    } else if (quesType === "maths") {
      // setTimeLeft(60);
    } else {
      // setTimeLeft(40);
    }
  };

  const fetchQuestions = async (language) => {
    setLoading(true);
    try {
      quetionsLength();
      const fetchedQuestions = {
        question: selectedLanguage === "hi" ? data.questionHin : data.question,

        options: selectedLanguage === "hi" ? data.optionsHin : data.options,

        answer: selectedLanguage === "hi" ? data.answerHin : data.answer,

        answerEng: data.answer,
        answerHin: data.answerHin,
      };
      setQuestions([fetchedQuestions]);
    } catch (error) {
      console.error("Error fetching questions:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
    setIsSubmitted(false);
  };

  const handleSubmit = async () => {
    if (selectedOption === null) {
      toast({
        title: "Please select an option.",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    setShowTimerButton(false);

    const activeContestId = contestIdFromState;

    const obj = {
      questionId: data?._id,
      answer: selectedOption,
      timeTaken: getQuestionTimeTaken(),
      contestId: activeContestId,
    };

    try {
      setLoading(true);

      const res = await axios.post(`submitContestAnswer`, obj);

      if (res) {
        syncContestAttemptTiming(res.data);
        setSelectedOption(null);
        setIsSubmitted(false);
        setIsCorrect(false);

        if (
          !res?.data?.nextQestion ||
          res?.data?.message === "No questions available"
        ) {
          await handleContestFinished({ shouldSubmitContest: true });
        } else {
          setData(res?.data?.nextQestion);
          setShowTimerButton(true);
        }
      }
    } catch (error) {
      console.error("Error submitting answer:", error);
      errorToast(error?.response?.data?.message || "Failed to submit answer");

      if (error?.response?.data?.message?.includes("time has ended")) {
        setTimeUp(true);
        setAutoSubmittedOnExpiry(false);
        confirmSubmitContest({ shouldNavigate: false });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSkip = async () => {
    setShowTimerButton(false);

    const activeContestId = contestIdFromState;

    const obj = {
      questionId: data?._id,
      type: "skip",
      timeTaken: getQuestionTimeTaken(),
      contestId: activeContestId,
    };

    try {
      setLoading(true);

      const res = await axios.post(`submitContestAnswer`, obj);

      if (res) {
        syncContestAttemptTiming(res.data);
        setCompleteData((prev) => ({
          ...prev,
          skipCount: (prev.skipCount || 0) + 1,
        }));

        setSelectedOption(null);
        setIsSubmitted(false);
        setIsCorrect(false);

        if (
          !res?.data?.nextQestion ||
          res?.data?.message === "No questions available"
        ) {
          await handleContestFinished({ shouldSubmitContest: true });
        } else {
          setData(res?.data?.nextQestion);
          setShowTimerButton(true);
        }
      }
    } catch (error) {
      console.error("Error skipping question:", error);
      errorToast(error?.response?.data?.message || "Failed to skip question");

      if (error?.response?.data?.message?.includes("time has ended")) {
        setTimeUp(true);
        setAutoSubmittedOnExpiry(false);
        confirmSubmitContest({ shouldNavigate: false });
      }
    } finally {
      setLoading(false);
    }
  };

  const confirmSubmitContest = async ({
    shouldNavigate = true,
    shouldOpenResultModal = false,
  } = {}) => {
    // Prevent double submission
    if (contestCompleted || submittingContestRef.current) return;
    if (!shouldNavigate && autoSubmitRef.current) return;

    try {
      submittingContestRef.current = true;

      if (!shouldNavigate) {
        autoSubmitRef.current = true;
      }

      setLoading(true);
      const activeContestId = contestIdFromState;
      const res = await axios.post("submitContest", {
        contestId: activeContestId,
      });

      if (res?.data?.success) {
        setContestCompleted(true);
        successToast("Contest submitted successfully");
        const summary =
          res?.data?.result || res?.data?.data
            ? normalizeContestSummary(res?.data?.result || res?.data?.data)
            : await fetchContestSummary();

        if (summary) {
          setContestSummary(summary);
        }

        if (shouldOpenResultModal) {
          setContestResultModal(true);
        }

        if (shouldNavigate) {
          navigate("/dash/contest-result", {
            state: { contestId: activeContestId, returnUrl },
          });
        }
      }
    } catch (error) {
      const message =
        error?.response?.data?.message || "Failed to submit contest";

      if (
        message.toLowerCase().includes("already") &&
        message.toLowerCase().includes("submit")
      ) {
        setContestCompleted(true);
        const summary = await fetchContestSummary();
        if (summary) {
          setContestSummary(summary);
        }

        if (shouldOpenResultModal || !shouldNavigate) {
          setContestResultModal(true);
        }
      } else {
        errorToast(message);
      }
    } finally {
      submittingContestRef.current = false;
      setLoading(false);
      setShowSubmitModal(false);
    }
  };

  const handleViewScorecard = async () => {
    setTimeUp(false);
    setAutoSubmittedOnExpiry(false);
    await fetchContestSummary();
    setContestResultModal(true);
  };
  const handleSubmitContest = () => {
    const totalAnswered =
      Number(completeData?.rightCount || 0) +
      Number(completeData?.wrongCount || 0) +
      Number(completeData?.skipCount || 0);
    console.log(totalQuestions, "total questions");

    // Agar questions baki hain ya time chal raha hai
    if (!TimeUp && totalAnswered < totalQuestions) {
      setShowSubmitModal(true);
    } else {
      confirmSubmitContest();
    }
  };

  const solvedQuestions = useMemo(() => {
    return (
      Number(completeData?.rightCount || 0) +
      Number(completeData?.wrongCount || 0) +
      Number(completeData?.skipCount || 0)
    );
  }, [completeData]);

  const handleNextQuestion = () => {
    setShowButton(false);
    setSelectedOption(null);
    setIsTimeout(false);
    setIsSubmitted(false); // Reset submitted state
    setIsCorrect(false); // Reset correct state
    fetchData();
    // clearInterval(timerRef.current);
    startTimer();
  };

  const startTimer = () => {
    if (timerRef.current) {
      // clearInterval(timerRef.current);
    }

    timerRef.current = setInterval(() => {
      // setTimeLeft((prevTimeLeft) => {
      //   if (prevTimeLeft <= 1) {
      //     clearInterval(timerRef.current);
      //     setShowButton(true);
      //     setIsDisabled(true);
      //     setIsTimeout(true);
      //     return 0;
      //   }
      //   return prevTimeLeft - 1;
      // });
    }, 1000);
  };

  useEffect(() => {
    if (Object.keys(userdata).length == 0) {
      axios
        .get("me")
        .then((response) => {
          setUserdata(response?.data?.result);
        })
        .catch((err) => {
          errorToast(
            err?.response?.data?.message || "Failed to load user data",
          );
        });
    }
  }, [userdata]);

  useEffect(() => {
    const activeContestId = contestIdFromState;
    if (!activeContestId) return;

    axios
      .get("getSubmittedContestAnswerRightCount", {
        params: { contestId: activeContestId },
      })
      .then((response) => {
        const userdata = response?.data?.result;
        setCompleteData({
          rightCount: userdata?.totalRightAnswerCount,
          wrongCount: userdata?.totalWrongAnswerCount,
          skipCount: userdata?.totalSkipCount || 0,
        });
      })
      .catch((err) => {
        errorToast(
          err?.response?.data?.message || "Failed to load contest data",
        );
      });
  }, [data, user, contestIdFromState]);

  const generateOptionLabel = (index) => {
    return String.fromCharCode(65 + index);
  };

  const renderQuestion = () => {
    return (
      <>
        {loading ? (
          <div className="flex min-h-[280px] items-center justify-center">
            <Loding />
          </div>
        ) : (
          <div className="w-full">
            {/* Question Card */}
            <div className="mb-2 flex items-start text-left  justify-between gap-3 p-4 bg-purple-50 mt-5 border border-purple-300 rounded-[10px]">
              <p className="text-[13px] font-medium leading-relaxed text-[#222] sm:text-sm lg:text-base">
                {questions[0]?.question}
              </p>
            </div>
            <div className="rounded-xl px-4 py-2 shadow-sm">
              {/* Options */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
                {questions[0]?.options?.map((option, index) => {
                  const isSelected = selectedOption === option;

                  const optionClass = isSelected
                    ? "border-2 border-[#562566] bg-[#F1EAF6]"
                    : "border border-[#DADADA] bg-white hover:bg-gray-50";

                  return (
                    <button
                      key={index}
                      type="button"
                      disabled={isSubmitted || TimeUp || isDisabled}
                      onClick={() =>
                        handleOptionChange({ target: { value: option } })
                      }
                      className={`flex w-full items-center justify-between rounded-lg shadow-lg px-4 py-2 text-left transition ${optionClass}`}
                    >
                      <div className="flex items-center gap-3">
                        <span
                          className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full border transition-all ${
                            isSelected
                              ? "border-[#562566] bg-[#562566]"
                              : "border-gray-400 bg-white"
                          }`}
                        >
                          {isSelected ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-3 w-3 text-white"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                              strokeWidth={3}
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M5 13l4 4L19 7"
                              />
                            </svg>
                          ) : null}
                        </span>

                        <span className="text-[13px] font-medium text-[#222] sm:text-sm">
                          {option}
                        </span>
                      </div>
                    </button>
                  );
                })}
              </div>

              {/* Skip inside question card */}
              <div className="mt-4 flex justify-end">
                <button
                  type="button"
                  onClick={handleSkip}
                  disabled={TimeUp || isDisabled}
                  className={`flex items-center gap-1 rounded-lg bg-white px-4 py-2 text-sm font-bold shadow-sm ${
                    TimeUp || isDisabled
                      ? "cursor-not-allowed text-gray-400"
                      : "text-[#F5A623]"
                  }`}
                >
                  Skip
                  <FaAngleRight size={16} />
                </button>
              </div>
            </div>
          </div>
        )}
      </>
    );
  };

  const [TimeUp, setTimeUp] = useState(false);
  useEffect(() => {
    const timerEndTime = contestAttemptTiming?.expiresAt || userContestdata?.endTime;
    if (!timerEndTime) return;
    const EndTime = new Date(timerEndTime);
    const interval = setInterval(() => {
      const now = new Date();
      if (now >= EndTime) {
        setTimeUp(true);
        // If using endTime (not expiresAt), it's a contest-wide timeout, not user-specific
        if (contestAttemptTiming?.expiresAt && new Date(contestAttemptTiming.expiresAt).getTime() === EndTime.getTime()) {
          setAutoSubmittedOnExpiry(true);
        } else {
          setAutoSubmittedOnExpiry(false);
        }
        clearInterval(interval);
        // Stop the per-question timer when contest time ends
        if (timerRef.current) {
          clearInterval(timerRef.current);
        }
        // Auto-submit the contest when time ends
        confirmSubmitContest({ shouldNavigate: false });
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [contestAttemptTiming?.expiresAt, userContestdata?.endTime]);

  return (
    <div className="min-h-screen bg-[#F5F5F7] px-4 py-4 lg:pt-14">
      <div className="mx-auto flex min-h-[calc(100vh-32px)] w-full max-w-[430px] flex-col lg:max-w-[900px]">
        {/* Top Header */}
        <div className="mb-4 lg:mt-10 flex items-center justify-between">
          <button
            type="button"
            onClick={() => navigate(returnUrl)}
            className="flex h-10 w-10 items-center justify-center rounded-full bg-white text-gray-500 shadow-sm"
          >
            <FaAngleRight size={18} className="rotate-180" />
          </button>
          <EngHinToggleButton
            selectedLanguage={selectedLanguage}
            onLanguageChange={setSelectedLanguage}
          />
          <button
            type="button"
            onClick={handleSubmitContest}
            className="rounded-[10px] bg-[#562566] px-10 py-3 text-md font-bold text-white shadow-md"
          >
            Submit
          </button>
        </div>

        {/* Top Info Strip */}
        <div className="mb-3 rounded-[30px] border border-[#E7E7E7] bg-gray-100 px-4 py-3 shadow-sm">
          <div className="flex items-center justify-between gap-3">
            {/* Timer */}
            <div className="flex items-center gap-2 rounded-full bg-yellow-50 px-3 py-2">
              <Clock size={18} className="text-[#FF4D4F]" />
              <span className="text-sm font-bold text-[#FF4D4F]">
                {formatTimeLeft(timeLeft)}
              </span>
            </div>

            {/* Question Count */}
            <div className="text-xs font-medium text-[#111]">
              {solvedQuestions}/{totalQuestions || 0}
            </div>
          </div>
        </div>

        {/* Question Area */}
        <div className="flex-1">
          {data ? (
            renderQuestion()
          ) : (
            <div className="rounded-xl bg-white p-8 text-center text-sm text-gray-500 shadow-sm">
              Loading Question...
            </div>
          )}
        </div>

        {/* Bottom Button */}
        <div className="mt-1 pb-16">
          {showButton ? (
            <button
              onClick={handleNextQuestion}
              className="flex h-14 w-full items-center justify-center gap-2 rounded-xl bg-[#562566] text-sm font-bold text-white shadow-lg"
            >
              Next Question <ArrowRight size={18} />
            </button>
          ) : (
            <button
              onClick={handleSubmit}
              disabled={TimeUp || isDisabled}
              className={`h-14 w-full rounded-xl text-sm font-bold shadow-lg ${
                TimeUp || isDisabled
                  ? "cursor-not-allowed bg-gray-300 text-gray-500"
                  : "bg-[#562566] text-white"
              }`}
            >
              {TimeUp ? "Contest Ended" : "Save & Next"}
            </button>
          )}
        </div>
      </div>

      {/* Submit Modal */}
      {showSubmitModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4 backdrop-blur-sm">
          <div className="w-full max-w-sm rounded-3xl bg-white p-6 text-center shadow-2xl">
            <div className="mb-4 flex justify-center">
              <AlertCircle size={36} className="text-red-500" />
            </div>

            <h2 className="mb-3 text-xl font-bold text-[#34163F]">
              Submit Contest Early?
            </h2>

            <p className="mb-6 text-sm text-gray-500">
              You still have unanswered questions and remaining time.
            </p>

            <div className="flex justify-center gap-3">
              <button
                onClick={() => setShowSubmitModal(false)}
                className="rounded-xl bg-gray-100 px-5 py-3 text-sm font-semibold text-gray-600"
              >
                Cancel
              </button>

              <button
                onClick={() =>
                  confirmSubmitContest({
                    shouldNavigate: false,
                    shouldOpenResultModal: true,
                  })
                }
                className="rounded-xl bg-[#562566] px-5 py-3 text-sm font-semibold text-white"
              >
                Yes, Submit
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Times Up Modal */}
      {TimeUp && (
        <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/50 px-4 backdrop-blur-sm">
          <div className="relative w-full max-w-sm rounded-[30px] bg-white px-6 py-8 text-center shadow-2xl">
            {/* Close Button */}
            <button
              onClick={() => {
                setTimeUp(false);
                setAutoSubmittedOnExpiry(false);
              }}
              className="absolute right-4 top-4 flex h-10 w-10 items-center justify-center rounded-full bg-[#F3ECF7]"
            >
              <X size={22} className="text-[#6B5A7A]" />
            </button>

            {/* Icon */}
            <div className="mx-auto mb-5 flex h-32 w-32 items-center justify-center rounded-full bg-[#FF3B30]">
              <img
                src={TimerImage}
                alt="time up"
                className="h-20 w-20 object-contain"
              />
            </div>

            {/* Title */}
            <h2 className="mb-3 text-4xl font-bold text-black">Time UP!</h2>

            {/* Subtitle */}
            <p className="mb-4 text-lg leading-9 text-[#333]">
              The countdown has ended. Choose what you want to view next.
            </p>

            {/* Buttons */}
            <div className="space-y-5">
              {autoSubmittedOnExpiry ? (
                <button
                  onClick={handleViewScorecard}
                  className="h-16 w-full rounded-full bg-[#EFEAF7] text-2xl font-medium text-[#562566] shadow-md"
                >
                  Summary
                </button>
              ) : (
                <>
                  <button
                    onClick={handleViewScorecard}
                    className="h-16 w-full rounded-full bg-[#EFEAF7] text-2xl font-medium text-[#562566] shadow-md"
                  >
                    View Scorecard
                  </button>

                  <button
                    onClick={() => {
                      setTimeUp(false);
                      navigate("/dash/contest-result", {
                        state: { contestId: contestIdFromState, returnUrl },
                      });
                    }}
                    className="h-16 w-full rounded-full bg-[#562566] text-2xl font-medium text-white shadow-md"
                  >
                    View Result
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      )}
      <ContestResultModal
        isOpen={contestResultModal}
        onClose={() => {
          setContestResultModal(false);
          navigate(returnUrl);
        }}
        result={contestSummary}
        contestData={contestSummary}
        onGoDashboard={() => {
          setContestResultModal(false);
          navigate(returnUrl);
        }}
      />
    </div>
  );
};

export default ContestQuestion;
